import React, { createContext, ReactNode, useContext, useState } from "react"

import { generateBlurProps } from "@fuse/sharedComponents/blurWrapper/blurHelpers"
import { blurKeys } from "@fuse/sharedComponents/blurWrapper/blurKeysList"

interface BlurContextType {
  blurValues: Record<string, any> // Updated to work with dynamic `BlurWrapper` props
  setBlurValues: (
    key: string,
    overlayColor: string,
    overlayOpacity: string,
    blurIntensity: string,
  ) => void
}

const BlurContext = createContext<BlurContextType | undefined>(undefined)

export const BlurProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [blurValues, setBlurValuesState] = useState<Record<string, any>>({
    // Initialize values dynamically
    ...generateBlurProps(blurKeys),
  })

  const setBlurValues = (
    key: string,
    overlayColor: string,
    overlayOpacity: string,
    blurIntensity: string,
  ) => {
    setBlurValuesState((prevValues) => ({
      ...prevValues,
      [`${key}-overlayColor`]: overlayColor,
      [`${key}-overlayOpacity`]: overlayOpacity,
      [`${key}-blurIntensity`]: blurIntensity,
    }))
  }

  return (
    <BlurContext.Provider value={{ blurValues, setBlurValues }}>
      {children}
    </BlurContext.Provider>
  )
}

export const useBlurContext = () => {
  const context = useContext(BlurContext)
  if (!context) {
    throw new Error("useBlurContext must be used within a BlurProvider")
  }
  return context
}
